<template>
  <b-popover :target="selector"
             :placement="placement"
             :custom-class="tutorial.class"
             triggers="manual" ref="popover"
             :variant="tutorial.variant || 'primary'">
    <template #title v-if="tutorial.title">
      {{tutorial.title}}
    </template>

    <span v-html="content" />

    <div id="buttons">
      <b-button @click="prev"
                variant="info"
                :disabled="is_first">
        Prev
      </b-button>

      <b-button @click="close">
        Close
      </b-button>

      <b-button @click="next"
                variant="info"
                :disabled="is_last">
        Next
      </b-button>
    </div>
  </b-popover>
</template>

<script>
import Authentication from "../mixins/authentication"

export default{
  name: 'UserTutorialPopup',

  props : {
    id : {
      type : Number,
      required : true
    },

    tutorial : {
      type : Object,
      required : true
    }
  },

  mixins : [
    Authentication
  ],

  computed : {
    tutorials () {
      return this.$parent.tutorials;
    },

    is_first (){
      return this.id == 0;
    },

    is_last () {
      return this.id == this.tutorials.length - 1;
    },

    content (){
      return (this.tutorial.content || "") +
        (this.logged_in ? (this.tutorial.auth_content   || "") :
                          (this.tutorial.noauth_content || ""));
    },

    selector (){
      return this.tutorial.md_selector && this.mq_lte_md ?
             this.tutorial.md_selector :
             this.tutorial.selector;
    },

    placement (){
      return this.tutorial.md_placement && this.mq_lte_md ?
             this.tutorial.md_placement :
             this.tutorial.placement;
    }
  },

  methods : {
    open (){
      this.$refs.popover.$emit('open');
    },

    close (){
      this.$refs.popover.$emit('close');
    },

    prev () {
      this.$parent.prev_tutorial();
    },

    next () {
      this.$parent.next_tutorial();
    },
  }
}
</script>

<style>
.popover.hide_arrow .arrow {
  visibility:hidden;
}

#buttons{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5px;
}

#buttons button{
  margin: 0 5px;
}
</style>
